import React from 'react';
import ReactDOM from 'react-dom/client';  // Use the correct import for React 18
import './index.css';
import './styles/transitions.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));  // Create root using React 18's API
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);